export const BEYOND_WORDS_SCRIPT =
  "https://proxy.beyondwords.io/npm/@beyondwords/player@0.4.2/dist/umd.js";
export const BEYOND_WORDS_API_BASE_URL = "https://api.beyondwords.io/v1";
export const TOOLTIP_STORAGE_KEY = "hasSeenTTSTooltip";
export const CRAWL_START_DATE = "Jul 17, 2025";

const playlistArticleLimit = Number(
  import.meta.env.VITE_BW_PLAYLIST_ARTICLE_LIMIT,
);
export const PLAYLIST_ARTICLE_LIMIT = Number.isFinite(playlistArticleLimit)
  ? playlistArticleLimit
  : 0;

export const ENABLE_BW_PLAYLIST =
  import.meta.env.VITE_ENABLE_BW_PLAYLIST === "1";
